var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.5C2 3.67157 2.67157 3 3.5 3H20.5C21.3284 3 22 3.67157 22 4.5C22 5.15311 21.5826 5.70873 21 5.91465V15C21 16.6569 19.6569 18 18 18H14.4142L16.6569 20.2426C17.0474 20.6331 17.0474 21.2663 16.6569 21.6568C16.2663 22.0473 15.6332 22.0473 15.2426 21.6568L11.7071 18.1213C11.6985 18.1127 11.6902 18.104 11.682 18.0952C11.6738 18.1041 11.6654 18.1127 11.6568 18.1213L8.12128 21.6569C7.73076 22.0474 7.09759 22.0474 6.70707 21.6569C6.31654 21.2663 6.31654 20.6332 6.70707 20.2426L8.94971 18H6C4.34315 18 3 16.6569 3 15V5.91465C2.4174 5.70873 2 5.15311 2 4.5ZM8 12C7.44772 12 7 12.4477 7 13V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V13C9 12.4477 8.55228 12 8 12ZM11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V10ZM16 7C15.4477 7 15 7.44772 15 8V14C15 14.5523 15.4477 15 16 15C16.5523 15 17 14.5523 17 14V8C17 7.44772 16.5523 7 16 7Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.7c6003c4ed04b78813fcba44274e81e6.svg";
export { ForwardRef as ReactComponent };